<template>
  <div class="wrapper-local project-box box posrel df">
    <div class="one-row df fdr min-width-1">
      <div class="profile-photo-image posrel">
        <img v-if="taskImage" class="profile-image" v-bind:src="taskImage" alt="" >
        <img v-on:click="uploadPhotoStart()" src="/images/profile-icons/Edit-Profile-Pen.png" class="posabs edit-profile-icon" alt="">
        <input v-on:change="uploadPhotoContinue()" v-bind:ref="'fileInput' + taskIndex" v-bind:id="'fileUploadButton' + taskIndex" style="opacity: 0; width: 0; height: 0; position: absolute;" type="file" accept="image/*" />
      </div>
      <div class="half-width df fdr aic ml1">
        <input type="text" class="input0 w100p" v-model="taskName" v-on:change="saveThisTask()">
      </div>
    </div>

    <div class="one-row df fdr">
      <div class="df fdc f1 aic jcc task-toggles">
        <span class="df w100p">
          <img v-if="taskFullType == 'hourlyElements'" src="/images/Price-Blue.svg" alt="" v-on:click="flipTaskType()" class="bigger-icons">
          <img v-else src="/images/Price-Grey.svg" alt="" v-on:click="flipTaskType()" class="bigger-icons">
          <!-- <span v-else alt="" class="use-rate bigger-icons" v-on:click="flipTaskType()"></span> -->
          <p class="default-task" v-on:click="flipTaskType()">Hourly Rate</p>
        </span>
        <span class="df w100p">
          <img v-if="taskFullType == 'percentTasks'" src="/images/Percentage-Blue.svg" alt="" v-on:click="flipTaskType()" class="bigger-icons">
          <img v-else src="/images/Percentage-Grey.svg" alt="" v-on:click="flipTaskType()" class="bigger-icons">
          <!-- <span v-else alt="" class="use-rate bigger-icons" v-on:click="flipTaskType()"></span> -->
          <p class="use-rate-text" v-on:click="flipTaskType()">Variable Rate</p>
        </span>
      </div>
    </div>
    <!-- <span class="vertical-divider mr1"></span> -->

    <div class="one-row aic">
      <span class="input-wrapper rate-cost-inputs">
        <p class="float-label">Rate</p>
        <p class="float-addition1">{{ taskFullType == 'hourlyElements' ? '/h' : '' }}</p>
        <p class="float-addition2">$</p>
        <input type="number" class="input1" v-model="taskRate" v-on:change="saveThisTask()" v-on:keypress="validateInputValue" >
      </span>
    </div>

    <div class="one-row aic ml1">
      <span class="input-wrapper rate-cost-inputs">
        <p class="float-label">Cost</p>
        <p class="float-addition1">{{ taskFullType == 'hourlyElements' ? '/h' : '' }}</p>
        <p class="float-addition2">$</p>
        <input type="number" class="input1" v-model="taskCost" v-on:change="saveThisTask()" v-on:keypress="validateInputValue" >
      </span>
    </div>

    <div v-if="taskFullType == 'percentTasks'" class="one-row aic ml1">
      <span class="input-wrapper rate-cost-inputs">
        <p class="float-label">Percentage</p>
        <p class="float-addition1">%</p>
        <input type="number" class="input1" min="0" max="100" v-model="taskPercent" v-on:change="saveThisTask()" v-on:keypress="validateInputValue" >
      </span>
    </div>

    <div class="one-row df fdr ml1">
      <div class="df fdc f1 aic jcc task-toggles">
        <span class="df w100p">
          <img v-if="useDefaultTask" src="/images/Icon-Selected.svg" alt="" v-on:click="flipDefaultTask()">
          <span v-else alt="" class="use-rate" v-on:click="flipDefaultTask()"></span>
          <p class="default-task">Default Task</p>
        </span>
        <span class="df w100p">
          <img v-if="useRate" src="/images/Icon-Selected.svg" alt="" v-on:click="flipUseRate()">
          <span v-else alt="" class="use-rate" v-on:click="flipUseRate()"></span>
          <p class="use-rate-text" v-on:click="flipUseRate()">Use Task Rate</p>
        </span>
        <span class="df w100p">
          <img v-if="useCost == true" class="use-cost-selected" src="/images/Icon-Selected.svg" alt="" v-on:click="flipUseCost()">
          <span v-else alt="" class="use-cost" v-on:click="flipUseCost()"></span>
          <p class="use-cost-text" v-on:click="flipUseCost()">Use Task Cost</p>
        </span>
      </div>
    </div>
    <img class="delete-task" src="/images/DeleteIcon.png" v-on:click="deleteColumn($event)"/>
  </div>
</template>

<script>
export default {
  // import Login from '../components/Login'

  name: 'CompanyTask',
  data () {
    return {
      useDefaultTask: this.$store.getters.companyTasks[this.taskIndex].useDefaultTask || null,
      taskRate: this.$store.getters.companyTasks[this.taskIndex].hourlyRateOverride || null,
      taskCost: this.$store.getters.companyTasks[this.taskIndex].hourlyCostOverride || null,
      taskPercent: this.$store.getters.companyTasks[this.taskIndex].hourlyPercentOverride || null,
      taskName: this.$store.getters.companyTasks[this.taskIndex].name || null,
      useCost: this.$store.getters.companyTasks[this.taskIndex].useTaskCost || null,
      useRate: this.$store.getters.companyTasks[this.taskIndex].useTaskRate || null,
      taskImage: this.$store.getters.companyTasks[this.taskIndex].taskImage || null,
      taskFullType: this.$store.getters.companyTasks[this.taskIndex].taskType || 'hourlyElements'
    }
  },
  props: ['taskItem', 'taskIndex'],
  watch: {
    // myProp: function(valNew, valOld){
    //   console.log('THIRD - watch - myProp - ', valNew, ' ', valOld)
    // }
  },
  components: {

  },
  methods: {
    validateInputValue(e) {
      e = e || window.event;
      let keyCode = e.which || e.keyCode;
      if((keyCode > 31 && (keyCode < 48 || keyCode > 57)) && keyCode !== 46) {
        e.preventDefault();
      } else {
        return true;
      }
    },
    removePhoto () {
      var data = {
        companyid: this.$store.getters.myCompany,
        index: this.taskIndex
      }
      this.$store.dispatch('deleteCompanyTaskPhoto', data).then(() => {
        console.log('After deleteCompanyTaskPhoto')
      })
    },
    uploadPhotoStart () {
      console.log('start photo upload')
      this.$refs['fileInput' + this.taskIndex].click()
    },
    uploadPhotoContinue () {
      console.log('continue uploading photo')
      var inputElement = document.getElementById('fileUploadButton' + this.taskIndex)
      var fileList = inputElement.files
      if (fileList[0]) {
        console.log('THE FILE', fileList[0])
        var data = {
          file: fileList[0],
          companyid: this.$store.getters.myCompany,
          index: this.taskIndex
        }
        console.log('file exists')
        this.$store.dispatch('saveCompanyTaskImage', data).then(() => {
          console.log('after saveCompanyTaskImage')
        })
      }
    },
    deleteColumn (event) {
      event.stopPropagation()
      // if (this.$store.getters.companyTasks.length > 1) {
        var data = {
          companyid: this.$store.getters.myCompany,
          index: this.taskIndex
        }
        this.$store.dispatch('deleteCompanyTask', data).then(() => {
          console.log('after deleteCompanyTask')
        })
      // }
    },
    flipUseRate () {
      if (this.useRate == true) {
        this.useRate = null
      } else {
        this.useRate = true
      }
      this.saveThisTask()
    },
    flipDefaultTask () {
      console.log('flipDefaultTask')
      if (this.useDefaultTask == true) {
        this.useDefaultTask = null
      } else {
        this.useDefaultTask = true
      }
      this.saveThisTask()
    },
    flipUseCost () {
      if (this.useCost == true) {
        this.useCost = null
      } else {
        this.useCost = true
      }
      this.saveThisTask()
    },
    flipTaskType () {
      if (this.taskFullType == 'hourlyElements') {
        this.taskFullType = 'percentTasks'
      } else if (this.taskFullType == 'percentTasks') {
        this.taskFullType = 'hourlyElements'
      }
      this.saveThisTask()
    },
    deleteThisTask () {

    },
    saveThisTask () {
      var data = {
        companyid: this.$store.getters.myCompany,
        taskindex: this.taskIndex,
        hourlyRateOverride: this.taskRate,
        hourlyCostOverride: this.taskCost,
        hourlyPercentOverride: this.taskPercent,
        name: this.taskName,
        useDefaultTask: this.useDefaultTask,
        taskImage: this.taskImage,
        useTaskCost: this.useCost,
        useTaskRate: this.useRate,
        taskTypeNew: this.taskFullType,
        taskTypeStart: this.taskType,
      }
      this.$store.dispatch('changeCompanyTaskDetails', data).then(() => {
        console.log('after changeCompanyTaskDetails')
      })
    },
    cancelEdits () {
      this.useDefaultTask = this.$store.getters.companyTasks[this.taskIndex].useDefaultTask || null
      this.taskRate = this.$store.getters.companyTasks[this.taskIndex].hourlyRateOverride || null
      this.taskCost = this.$store.getters.companyTasks[this.taskIndex].hourlyCostOverride || null
      this.taskName = this.$store.getters.companyTasks[this.taskIndex].name || null
      this.useCost = this.$store.getters.companyTasks[this.taskIndex].useTaskCost || null
      this.taskImage = this.$store.getters.companyTasks[this.taskIndex].taskImage || null
      this.useRate = this.$store.getters.companyTasks[this.taskIndex].useTaskRate || null
      this.taskFullType = this.$store.getters.companyTasks[this.taskIndex].taskType || 'hourlyElements'
    }
  },
  computed: {
    companyTasks () {
      return this.$store.getters.companyTasks
    }
  },
  watch: {
    companyTasks (newVal, oldVal) {
      console.log('companyTasks changed', newVal, oldVal)
      // console.log('...', newVal, oldVal)
      this.cancelEdits()
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      console.log('mounted')
    })
  },
  updated: function () {
    this.$nextTick(function () {
      console.log('updated')
      // Code that will run only after the
      // entire view has been re-rendered
    })
  },
  created () {
    console.log('** Company Task Component Loaded', this.taskItem, this.$store.getters.companyTasks[this.taskIndex])
  }
}
</script>

<style scoped lang="scss">
@import "../../styles/settings.scss";

//
// Project Box
//
.project-box {
  padding: 35px 5px;
  margin-bottom: 35px;

  // div
  & > div {
    position: relative;
    min-width: unset;
    width: 20%;
    margin-left: 0px;
    padding-left: 30px;
    padding-right: 30px;
    &:after {
      content: '';
      width: 1px;
      height: 44px;
      background-color: #dfdfdf;
      top: 50%;
      transform: translateY(-50%);
      right: 0px;
      position: absolute;
    }
    &:nth-child(1) {
      flex: none;
      width: 300px;
      &:after {
        display: none;
      }
    }
    &:nth-child(2) {
      flex: none;
      width: 180px;
    }
    &:nth-child(5) {
      &:after {
        display: none;
      }
    }
    input {
      width: 100%;
      max-width: unset;
      margin-right: 0px;
    }
  }

  // Responsive Style
  // @media max-width: 1080px
  @media(max-width: 1080px) {
    flex-wrap: wrap;

    // div
    > div {
      width: 25%;
      &:nth-child(1) {
        width: 100%;
      }
      &:nth-child(2) {
        width: 25%;
      }
    }
  }

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    padding-left: 25px;
    padding-right: 25px;
    margin-bottom: 20px;

    // div
    > div {
      width: 50%;
      padding-left: 0px;
      padding-right: 0px;
      border-bottom: 1px solid #DFDFDF;
      padding-bottom: 15px;
      margin-bottom: 15px;
      &:after {
        display: none;
      }
      &:nth-child(1) {
        border-bottom: none;
        padding-bottom: 0px;
        margin-bottom: 0px;
        .half-width {width: 100%;}
      }
      &:nth-child(2) {
        flex-direction: unset;
        width: 100%;
        margin-bottom: 30px;
        .task-toggles {
          flex-wrap: wrap;
          justify-content: unset;
          flex-direction: unset;
          > span {
            width: 50%;
            margin-right: 0px;
          }
        }
      }
      &:nth-child(3) {
        padding-right: 12.5px;
      }
      &:nth-child(4) {
        padding-left: 12.5px;
      }
      &:nth-child(5) {
        width: 100%;
        border-bottom: none;
        padding-bottom: 0px;
        margin-bottom: 0px;
      }
    }
  }
}


//
// One Row
.one-row {
  display: flex;
}


.half-width {
  width: 50%;
}
.input-wrapper {
  position: relative;
  display: block;
  width: 100%;
}


  .float-label {
    position: absolute;
    top: -3px;
    transform: translateY(-100%);
    font-size: 12px;
    font-weight: 500;
    font-family: 'GG';
  }


.input-grey {
  padding: 20px;
  padding-right: 2px;
  height: 65px;
  border-radius: 5px;
  background-color: #F5F5F5;
  border: 0;
  font-size: 18px;
  letter-spacing: 0.64px;
  line-height: 25px;
}

.w25p {
  margin-right: 20px;
  width: calc(25% - 20px);
}

.w50p {
  margin-right: 20px;
  width: calc(50% - 20px);
}

.w100p {
  margin-right: 20px;
  width: calc(100% - 20px);
}
.input-grey {
  width: 100%;
}
.thirdButton {
  margin-right: 20px;
  width: calc(33.33% - 20px);
}
.button-white {
  background-color: white;
}
.float-addition1 {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}
.float-addition2 {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
}
.button-small {
  padding: 8px 12px;
  margin-left: 15px;
}
.task-type {
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  align-items: center;
  background-color: white;
  text-transform: capitalize;

  & > img {
    margin-right: 15px;
    height: 30px;
    width: 30px;
  }
}
.task-image {
  background-color: #eee;
  border-radius: 50%;
  height: 80px;
  width: 80px;
}
.use-cost-selected, .use-cost {
  /*margin-left: 35px;*/
}
.use-cost-selected, .use-rate-selected, .use-cost, .use-rate {
  height: 13px;
  width: 13px;
  border: 1px solid $primaryColor;
  border-radius: 50%;
}
.use-cost-selected, .use-rate-selected {
  border: 0;
}
.use-cost, .use-rate {
  /*background-color: #eee;*/
}

.use-rate-text, .use-cost-text {
  margin-left: 10px;
}
.default-task {
  margin-left: 10px;
}
.task-toggles {
  min-width: 150px;

  & > span {
    -ms-align-items: center;
    align-items: center;
  }
  .bigger-icons {
    height: 24px;
    width: 24px;
    border: none;
  }

  & > span:nth-of-type(2) {
    margin-top: 5px;
    margin-bottom: 5px;
  }

  & > span > img {
    height: 13px;
    width: 13px;
    border: 1px solid $primaryColor;
    border-radius: 50%;
  }

  color: $grey2;
  font-family: 'GG';
  font-size: 12px;
}
.company-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  object-position: center;
  border-radius: 50%;
}

.edit-profile-icon {
  width: 24px;
  height: 24px;
  background-color: $grey2;
  border-radius: 50%;
  object-fit: none;
  right: 0;
  top: 0;
  cursor: pointer;
}

.ml1 {
  margin-left: 30px;
}

.mr1 {
  margin-right: 30px;
}

.vertical-divider {
  align-self: center;
  width: 1px;
  min-width: 1px;
  height: 44px;
  background: $grey4;
}

.min-width-1 {
  min-width: 240px;
  width: 240px;
}

.input0 {
  width: 90px;
  max-width: 90px;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.delete-task {
  position: absolute;
  right: 15px;
  bottom: 15px;
  cursor: pointer;
}
</style>
